import { type ReactNode } from 'react'
import { useHasPermission } from '../../lib/hooks/usePermission'
import { AccessDeniedPage } from '../../features/auth/AccessDeniedPage'

interface PermissionGuardProps {
  children: ReactNode
  /**
   * Required permissions for this route/component (OR logic if multiple).
   * If undefined, no permission check is performed.
   */
  requiredPermissions?: string[]
  /**
   * When checking multiple permissions:
   * - true: require ALL permissions (AND logic)
   * - false: require ANY permission (OR logic, default)
   */
  requireAll?: boolean
}

export function PermissionGuard({
  children,
  requiredPermissions,
  requireAll = false,
}: PermissionGuardProps) {
  const hasPermission = useHasPermission(requiredPermissions || [], { requireAll })

  // If no permissions required, allow access
  if (!requiredPermissions || requiredPermissions.length === 0) {
    return <>{children}</>
  }

  // Check permissions
  if (!hasPermission) {
    return <AccessDeniedPage />
  }

  return <>{children}</>
}
